"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
const common_1 = require("../../common");
const models_1 = require("../../setup/models");
const estimating_manufacturing_info_model_1 = require("./estimating-manufacturing-info.model");
const location_manufacturing_info_model_1 = require("./location-manufacturing-info.model");
const product_class_model_1 = require("./product-class.model");
const product_cross_reference_model_1 = require("./product-cross-reference.model");
const product_manufacturer_model_1 = require("./product-manufacturer.model");
const product_price_break_model_1 = require("./product-price-break.model");
const product_unit_of_measure_model_1 = require("./product-unit-of-measure.model");
class Product extends common_1.MongoDocument {
}
exports.Product = Product;
//# sourceMappingURL=product.model.js.map